
import Model from './model.js';

export default class Payment extends Model {
	icon() {
		switch (true) {
			case this.paid == 1:
				return { icon: "IconTick", class: "bg-green-600/10 stroke-green-600", title: "Paid" }
				break;
			default:
				return { icon: "IconFalse", class: "bg-red-700/10 stroke-red-700", title: "Unpaid" }
		}
	}
}